'use client';

import { usePaymentMethod } from '@payments-checkout/shared/providers';
import { Divider } from '@stone-payments/jade';
import { useFormContext, useWatch } from 'react-hook-form';
import { usePageSharedData } from '../../../hooks/usePageSharedData';
import { DeliveryData } from '../../DeliveryData';
import { AddressFormComponent } from './addressFormComponent';
import { AddressHeader } from './addressHeader';

type AddressProps = {
  isStoneDelivery?: boolean;
  showShippingAddress?: boolean;
};

const BILLING_SCREEN = 'dados_cobranca';

export function Address({ isStoneDelivery = false, showShippingAddress = false }: AddressProps) {
  const { control } = useFormContext();
    const {
      paymentMethod,
    } = usePaymentMethod();
  const { paymentLinkIdData } =
    usePageSharedData();
  const billingCountry = useWatch({
    control,
    name: 'billing-address-country',
  }) as string | undefined;

  const withShipping = showShippingAddress && !(paymentMethod === 'pix' && paymentLinkIdData.data?.flow_settings?.pix_flow?.show_shipping_address_page === false);

  if (isStoneDelivery || withShipping) {
    return <DeliveryData showAddress={showShippingAddress} />;
  }

  return (
    <div>
      <AddressFormComponent
        formName="billing-address"
        screen={BILLING_SCREEN}
        header={
          <AddressHeader
            formName="billing-address"
            country={billingCountry ?? 'BR'}
            screen={BILLING_SCREEN}
          />
        }
      />
      <div className="block w-full py-jade-300">
        <Divider direction="horizontal" size="small" />
      </div>
    </div>
  );
}
